import Vue from 'vue'
import Vuex from 'vuex'
import mark from './modules/mark'
// import createLogger from '../../../src/plugins/logger'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    modules: {
        mark
    },
    strict: debug,
    // plugins: debug ? [createLogger()] : []
})
